import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service'
import { io } from 'socket.io-client';


@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.css']
})
export class SidemenuComponent implements OnInit {

  admin_data: any;
  visitor = [] as any;
  socket: any;

  constructor(public services: ApiService) { }

  ngOnInit(): void {
    this.admin_data = localStorage.getItem("admin_data");
    this.admin_data = JSON.parse(this.admin_data);
    // this.socket = io('https://ogc.mapedia.co.th/api/v2/lrfund/');
    this.services.get('m_countofuser').then((res: any) => {
      this.getCounter(res);
    })
    // this.socket.on('output', (res: any) => {
    //   this.getCounter(res);
    // });
  }

  async getCounter(data: any) {
    // let visitor = data
    let counnt_visitor = (data.length).toString()
    this.visitor = [];

    // await this.services.get('m_countofuser').then((res: any) => {
    //   visitor = res
    //   counnt_visitor = (visitor.length).toString()
    // })
    for (let j = 0; j < counnt_visitor.length; j++) {
      this.visitor.push(counnt_visitor[j])
    }
    for (let x = 0; x < 6; x++) {
      if (this.visitor.length < 6) {
        this.visitor.splice(0, 0, 0);
      }
    }
  }

  async onClick() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.getElementById('finances')!.classList.remove('active');
    document.getElementById('finance')!.classList.remove('show');
    document.getElementById('plans')!.classList.remove('active');
    document.getElementById('plan')!.classList.remove('show');
    document.getElementById('receivables')!.classList.remove('active');
    document.getElementById('receivable')!.classList.remove('show');

    // document.getElementById('finances')!.classList.toggle("active");
    // document.getElementById('finance')!.classList.toggle("show");
    // document.getElementById('plans')!.classList.toggle("active");
    // document.getElementById('plan')!.classList.toggle("show");
    // document.getElementById('receivables')!.classList.toggle("active");
    // document.getElementById('receivable')!.classList.toggle("show");
  }
}
